import { Card } from "../card";
import contextual from "../../../images/icon/contextual.svg";
import opt from "../../../images/icon/opt.svg";
import audience from "../../../images/icon/audience.svg";
const advantages = [
  {
    icon: audience,
    title: "Decreasing Access to Physicians",
    text: `<ul style="padding-left: 1.5rem;"> <li style="list-style:disc;">Claims data</li> <li style="list-style:disc;">All PII is stripped away and tokenized, making this data 100% HIPAA compliant</li></ul>`,
  },
  {
    icon: opt,
    title: "Limited Time and Stricter Policies",
    text: `<ul style="padding-left: 1.5rem;"><li style="list-style:disc;">1:1 Self-reported data via content network double opt-in </li>
            <li style="list-style:disc;">Meticulously maintained patient network with opt-ins, unbranded sites, surveys, and more</li>
        </ul>
        `,
  },
  {
    icon: contextual,
    title: "Marketing Teams Take the Lead",
    text: `<ul style="padding-left: 1.5rem;"> <li style="list-style:disc;"> Build audience made up of patients based on the content they read online. Also target them based on specific URL visitation (WebMD, Healthline, etc.) </li> </ul>`,
  },
];

export const PatientAdvantages = () => {
  return (
    <section>
      <h1 className="text-center">How Our Patient Targeting Works</h1>
      <p className="text-center">
        A multi-layered audience building model ensures maximum precision and
        full HIPAA compliance.
        <br />
        <span style={{ color: "#7BD825", fontSize: "16px" }}>
          Our approach combines three key components:
        </span>
      </p>
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
          margin: "0,auto",
          gap: "30px",
          justifySelf: "center",
        }}
        className="advantages"
      >
        {advantages.map((advantage) => (
          <Card
            icon={advantage.icon}
            title={advantage.title}
            text={advantage.text}
            minHeight="400px"
          />
        ))}
      </div>
    </section>
  );
};
